export const S = {
  APP_NAME: "Fintective",
  TAGLINE: "Financial Intelligence Dashboard",
  
  NAV_DASHBOARD: "Dashboard",
  NAV_FINDINGS: "Findings",
  NAV_TRANSACTIONS: "Transactions",
  NAV_PAYEES: "Payees",
  NAV_DETECTORS: "Detectors",
  NAV_FAMILY: "Family",
  NAV_SHARE: "Share & Earn",
  NAV_BILLING: "Billing",
  NAV_PROFILE: "Profile",
  NAV_ADMIN: "Admin",

  BADGE_INTELLIGENCE: "INTELLIGENCE FEED",
  BADGE_PAYEE_INTEL: "PAYEE INTELLIGENCE",
  BADGE_DETECTORS: "DETECTORS",
  BADGE_FAMILY: "FAMILY",
  BADGE_REFERRALS: "REFERRALS",
  BADGE_ACTIVE_SESSION: "Active Session",

  BTN_SYNC: "Sync Now",
  BTN_INVESTIGATE: "Investigate Now",
  BTN_RESOLVE: "Resolve",
  BTN_INVITE: "Invite",
  BTN_SAVE: "Save",
  BTN_LOGIN: "Sign In",
  BTN_LOGOUT: "Sign Out",
  SIDEBAR_HIDE_AMOUNTS: "Hide amounts",
  SIDEBAR_SHOW_AMOUNTS: "Show amounts",
  BTN_GOOGLE: "Continue with Google",
  BTN_UPGRADE: "Upgrade",
  BTN_MANAGE_BILLING: "Manage Billing",
  BTN_CONNECT_YNAB: "Connect YNAB",
  BTN_SELECT_PLAN: "Select Budget",
  BTN_ACCEPT_INVITE: "Accept Invite",
  BTN_REPORT: "Report",
  BTN_COPY: "Copy Link",
  BTN_CONTACT_SUPPORT: "Contact Support",

  STAT_TOTAL_CLUES: "Total Findings",
  STAT_ACTIVE_CASES: "Active Cases",
  STAT_RESOLVED: "Resolved",
  STAT_TOTAL: "Total",
  STAT_FLAGGED: "Flagged",
  STAT_SAFE: "Safe",

  TIER_FREE: "FREE",
  TIER_PRO: "PRO",
  TIER_PREMIUM: "PREMIUM",

  STATUS_TRIAL: "Trial",
  STATUS_MONTHLY: "Monthly",
  STATUS_YEARLY: "Yearly",
  STATUS_EXPIRED: "Expired",
  STATUS_TRIAL_EXPIRED: "Trial Expired",

  ERROR_RATE_LIMIT: "Too many requests. Please wait a moment.",
  ERROR_UNAUTHORIZED: "Session expired. Please sign in again.",
  ERROR_FORBIDDEN: "You don't have permission to access this resource.",
  TOAST_YNAB_SYNC_STARTED: "YNAB sync started",
  TOAST_YNAB_SYNC_FAILED: "Failed to start YNAB sync",
  TOAST_YNAB_SYNC_SENT: "Sync request sent",
  TOAST_YNAB_SYNC_COMPLETED: "YNAB sync completed",
  TOAST_YNAB_SYNC_RUNNING: "Sync is taking a little longer; it'll finish in the background",
  TOAST_YNAB_SYNC_IN_PROGRESS: "Sync already in progress",
  TOAST_INVESTIGATE_SENT: "Investigation request sent",
  TOAST_INVESTIGATE_COMPLETED: "Investigation completed",
  TOAST_INVESTIGATE_FAILED: "Failed to start investigation",
  TOAST_BILLING_PORTAL_FAILED: "Failed to open billing portal",
  TOAST_BILLING_CHECKOUT_FAILED: "Failed to start checkout",
  TOAST_BILLING_CHECKOUT_SUCCESS: "Payment received — your subscription is active",
  TOAST_BILLING_CHECKOUT_CANCELLED: "Checkout was not completed",
  TOAST_BILLING_CONFIRMING: "Confirming your subscription…",
  TOAST_BILLING_CONFIRMING_SLOW: "Still confirming your subscription — this can take a moment.",

  BILLING_CURRENT_PLAN: "Current Plan",
  BILLING_PLAN_STATUS_TRIAL: "Trial active",
  BILLING_PLAN_STATUS_BETA: "Beta access active",
  BILLING_PLAN_STATUS_TRIAL_EXPIRED: "Trial expired. Upgrade to keep investigations running.",
  BILLING_PLAN_STATUS_EXPIRED: "Subscription expired. Upgrade to resume full access.",
  BILLING_SECURITY_FREE_BADGE: "FREE forever",
  BILLING_SECURITY_FREE_HEADING: "Essential security detectors stay FREE",
  BILLING_SECURITY_FREE_DESCRIPTION: "Even after your trial expires, these security-conscious detectors will remain free. We know users rely on these protections, and we plan to keep supporting them.",
  BILLING_SECURITY_FREE_DETECTOR_DOUBLE_DIP: "Double Dip",
  BILLING_SECURITY_FREE_DETECTOR_NEW_PAYEE: "New Payee",
  BILLING_SECURITY_FREE_DETECTOR_WATCHED_PAYEE: "Watched Payee",
  BILLING_SECURITY_FREE_DETECTOR_FLAGGED_PAYEE: "Flagged Payee",
  BILLING_SECURITY_FREE_DETECTOR_GLOBAL_FLAGGED_PAYEE: "Global Flagged Payee",
  BILLING_BETA_PRICING_BADGE: "Beta",
  BILLING_BETA_PRICING_TITLE: "Currently free during active development",
  BILLING_BETA_PRICING_DESCRIPTION: "The price below is the planned post-beta price. When Fintective leaves beta, we will notify you before billing begins and give you a 30-day trial.",
  BILLING_BETA_DISABLED_TITLE: "Fintective is free during beta",
  BILLING_BETA_DISABLED_MESSAGE: "Fintective is in active development - and that's your gain: it's completely free right now. When we move out of beta, you'll be notified and placed on a trial period, giving you enough time to choose a plan.",
  BILLING_BETA_DISABLED_ACTION: "Got it",
  BILLING_PLAN_STATUS_MONTHLY: "Monthly subscription active",
  BILLING_PLAN_STATUS_YEARLY: "Yearly subscription active",
  BILLING_PRO_TITLE: "Pro",
  BILLING_PRO_PRICE: "$2.99 / Month",
  BILLING_PREMIUM_TITLE: "Premium",
  BILLING_PREMIUM_PRICE: "$1.99 / Month",
  BILLING_PREMIUM_NOTE: "Billed Yearly",
  BILLING_FEATURES_TITLE_PRO: "Pro Features",
  BILLING_FEATURES_TITLE_PREMIUM: "Premium Features",
  BILLING_HISTORY_TITLE: "Billing History",
  BILLING_HISTORY_EMPTY: "No billing history yet.",
  BILLING_LAST_PAYMENT_TITLE: "Last Payment",
  BILLING_LAST_PAYMENT_EMPTY: "No successful payment yet.",
  BILLING_LAST_PAYMENT_DATE: "Date",
  BILLING_LAST_PAYMENT_AMOUNT: "Amount",
  BILLING_LAST_PAYMENT_STATUS: "Status",
  BILLING_SUPPORT_TEXT: "Need help with billing?",
  SUBSCRIPTION_REQUIRED_TITLE: "Subscription required",
  SUBSCRIPTION_REQUIRED_DESCRIPTION: "Your trial or subscription has ended. Renew your subscription to restore Fintective access.",
  UPGRADE_TO_VIEW_TITLE: "Upgrade to view",
  UPGRADE_TO_VIEW_DESCRIPTION: "This page stays locked after your trial expires. Upgrade to restore full access.",
  UPGRADE_TO_VIEW_ADMIN_DESCRIPTION: "Admin reporting is disabled on expired plans until billing is restored.",

  EMPTY_FINDINGS: "No findings found. Run an investigation to detect anomalies.",
  EMPTY_TRANSACTIONS: "No transactions yet. Connect YNAB to import data.",
  ERROR_LOAD_GENERIC: "We couldn't load this right now. Please try again.",
  ERROR_RETRY: "Try again",
  EMPTY_PAYEES: "No payees found.",
  EMPTY_MEMBERS: "No members yet. Invite someone to get started.",
  NEED_CATEGORY: "Need Category",
  CATEGORIES_PERIOD_HINT: "Calculated over the past 12 months",

  // Fintective Score breakdown — each component is weighted (see per-component
  // max) and carries guidance on how to raise it.
  SCORE_BREAKDOWN_TITLE: "How to improve your score",
  SCORE_BREAKDOWN_SUBTITLE: "Each part is weighted differently. Here's what's holding you back and how to fix it.",
  SCORE_MAXED: "Maxed out — full points.",
  SCORE_DETECTORS_FIX: "Enable more detectors so Fintective investigates more of your spending.",
  SCORE_DETECTORS_CTA: "Manage detectors",
  SCORE_NOTIFICATIONS_FIX: "Turn on notifications for more detectors so you hear about new findings.",
  SCORE_NOTIFICATIONS_CTA: "Manage notifications",
  SCORE_YNAB_FIX: "Sync YNAB so your latest transactions are recent — within 3 days earns full points.",
  SCORE_YNAB_CTA: "Manage connection",
  SCORE_STALE_FIX: "Review and resolve findings — clues left unresolved for more than a week pull your score down.",
  SCORE_STALE_FIX_COUNT: "You have {count} unresolved finding{s} older than a week. Resolve them to recover points.",
  SCORE_STALE_CTA: "Review findings",
  SCORE_DEVIATION_NO_ALLOCATION: "Set a category allocation first. Until you do, deviation stays at 0 — once set, we calculate how closely your spending matches your plan.",
  SCORE_DEVIATION_FIX: "Bring your actual category spending closer to your target allocation, or refine the targets.",
  SCORE_DEVIATION_CTA_SET: "Set allocation",
  SCORE_DEVIATION_CTA_REVIEW: "Review allocation",

  DASHBOARD_LOADING_TITLE: "Preparing your dashboard",
  DASHBOARD_LOADING_SUBTITLE: "We are loading your latest financial data.",
  DASHBOARD_ERROR_TITLE: "Dashboard unavailable",
  DASHBOARD_ERROR_SUBTITLE: "We could not load your latest financial data right now.",
  DASHBOARD_RETRY: "Try again",

  ONBOARDING_TITLE: "Connect your YNAB budget",
  ONBOARDING_DESCRIPTION: "Connect YNAB so Fintective can inspect your transactions, find unusual activity, and build your financial intelligence dashboard.",
  ONBOARDING_PRIMARY: "Connect YNAB",
  ONBOARDING_SECONDARY: "I'll do this later",
  ONBOARDING_WHERE_TITLE: "Where things live",
  ONBOARDING_TRANSACTIONS_TITLE: "Transactions",
  ONBOARDING_TRANSACTIONS_LOCATION: "Left sidebar, Budget section",
  ONBOARDING_TRANSACTIONS_DESCRIPTION: "A full list of imported YNAB transactions.",
  ONBOARDING_FINDINGS_TITLE: "Findings",
  ONBOARDING_FINDINGS_LOCATION: "Left sidebar, Investigation section",
  ONBOARDING_FINDINGS_DESCRIPTION: "All clues Fintective detects, including unusual charges, new merchants, spending spikes, and other alerts.",
  ONBOARDING_MONEY_FLOW_TITLE: "Money Flow",
  ONBOARDING_MONEY_FLOW_LOCATION: "Left sidebar, Budget section",
  ONBOARDING_MONEY_FLOW_DESCRIPTION: "A monthly view of income, outflows, and spending movement.",
  ONBOARDING_MONTHLY_PAYMENTS_TITLE: "Monthly Payments",
  ONBOARDING_MONTHLY_PAYMENTS_LOCATION: "Left sidebar, Budget section",
  ONBOARDING_MONTHLY_PAYMENTS_DESCRIPTION: "Recurring bills and subscription-like payments Fintective identifies.",
  ONBOARDING_DETECTORS_TITLE: "Detectors",
  ONBOARDING_DETECTORS_LOCATION: "Settings page, Detectors tab",
  ONBOARDING_DETECTORS_DESCRIPTION: "Controls for which checks Fintective runs and which ones can notify you.",
  ONBOARDING_NOTIFICATIONS_TITLE: "Notifications",
  ONBOARDING_NOTIFICATIONS_LOCATION: "Settings page, Notifications tab",
  ONBOARDING_NOTIFICATIONS_DESCRIPTION: "Email alert preferences.",
  ONBOARDING_FORMATTING_TITLE: "Formatting",
  ONBOARDING_FORMATTING_LOCATION: "Settings page, Formatting tab",
  ONBOARDING_FORMATTING_DESCRIPTION: "Currency, number, and date display settings.",
  ONBOARDING_HELP_TITLE: "Help",
  ONBOARDING_HELP_LOCATION: "Left sidebar, Settings & Account section",
  ONBOARDING_HELP_DESCRIPTION: "A guide to how Fintective works and what each area is for.",
  ONBOARDING_SUPPORT_TITLE: "Support",
  ONBOARDING_SUPPORT_LOCATION: "Left sidebar, Settings & Account section",
  ONBOARDING_SUPPORT_DESCRIPTION: "Reach support with questions or issues.",
  ONBOARDING_HELP_NOTE_TITLE: "Need help?",
  ONBOARDING_HELP_NOTE_DESCRIPTION: "The Help page explains how Fintective works and what each area is for. If you have a question or run into an issue, you can reach us from the Support page.",
  ONBOARDING_REPEAT: "Show onboarding again",
  ONBOARDING_REPEAT_DESCRIPTION: "Replay the quick guide to YNAB connection and dashboard areas.",

  LOGIN_TITLE: "Welcome to Fintective",
  LOGIN_SUBTITLE: "Sign in to access your financial intelligence dashboard",
  ERROR_INVALID_CREDENTIALS: "Username or password is incorrect.",
  ERROR_FORGOT_PASSWORD_GENERIC: "Something went wrong. Please try again.",
  AUTH_ACTION_LOADING_TITLE: "Checking your secure link",
  AUTH_ACTION_LOADING_DESCRIPTION: "Please wait while Fintective validates this request.",
  AUTH_ACTION_UNKNOWN_TITLE: "Unsupported link",
  AUTH_ACTION_UNKNOWN_DESCRIPTION: "This Firebase action link is not supported by Fintective.",
  AUTH_ACTION_EXPIRED_TITLE: "Invalid or expired link",
  AUTH_ACTION_RESET_EXPIRED_DESCRIPTION: "This password reset link is invalid or has expired.",
  AUTH_ACTION_VERIFY_EXPIRED_DESCRIPTION: "This verification link is invalid or has expired.",
  AUTH_ACTION_REQUEST_NEW_LINK: "Request a new link",
  AUTH_ACTION_BACK_TO_SIGN_IN: "Back to Sign In",
  AUTH_ACTION_PASSWORD_TITLE: "Set new password",
  AUTH_ACTION_PASSWORD_DESCRIPTION: "Enter your new password for this Fintective account.",
  AUTH_ACTION_PASSWORD_UPDATED_TITLE: "Password updated",
  AUTH_ACTION_PASSWORD_UPDATED_DESCRIPTION: "Your password has been reset successfully. You can now sign in.",
  AUTH_ACTION_VERIFY_TITLE: "Verifying your email",
  AUTH_ACTION_VERIFY_SUCCESS_TITLE: "Email verified",
  AUTH_ACTION_VERIFY_SUCCESS_DESCRIPTION: "Your Fintective account email has been verified. You can now sign in.",
  AUTH_ACTION_PASSWORD_MIN: "Password must be at least 8 characters",
  AUTH_ACTION_PASSWORD_MISMATCH: "Passwords do not match",
  AUTH_ACTION_PASSWORD_FAILED: "Failed to reset password. Please request a new link.",
  INVITE_PREVIEW_GENERIC: "Your request has been received. If the invite code is valid, you will be added to the agency.",

  CONSENT_TITLE: "Before you continue",
  CONSENT_SUBTITLE: "We need your confirmation to create your account.",
  CONSENT_CHECKBOX: "I confirm I am at least 18 years old and I agree to the Terms of Service and Privacy Policy.",
  CONSENT_CONFIRM: "Continue",
  CONSENT_DECLINE: "Cancel",
  CONSENT_DECLINE_EXISTING: "Sign out",
} as const;
